import React, { useCallback, useEffect, useRef, useState } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { Iconfont } from "../../../../components/icon/iconfont";
import Cache from "../../../../../utils/cache";

const PopupPrompt = props =>{
    useStyles(cls);
    const { buttonPopups } = props;
    const [show, setShow] = useState(false);
    const timerRef = useRef();

    useEffect(() =>{
        const showPopup = Cache.get('cart-prompt');
        let timerLocaRef;
        if(!showPopup){
            timerLocaRef = setTimeout(() =>{
                setShow(true);
                Cache.set('cart-prompt', 1, (24*60*60)*1000);

                if(window.GeekoSensors){
                    window.GeekoSensors.Track('Popup_PlaceOrder', {
                        action: "exposure",
                    })
                }

                timerRef.current = setTimeout(() =>{
                    setShow(false);
                }, 5000);
            }, 10000);
        }

        return () =>{
            clearTimeout(timerLocaRef);
        }
    }, []);

    const onClose = useCallback(() =>{
        setShow(false);
        clearTimeout(timerRef.current);


        if(window.GeekoSensors){
            window.GeekoSensors.Track('Popup_PlaceOrder', {
                action: "close",
            })
        }
    }, []);

    return <React.Fragment>
        {
            show && <div className={`${cls.PopupPrompt} ${props?.className?props.className:""}`}>
                <div className={cls.Container}>
                    <div className={cls.Image}>
                        <img src={buttonPopups?.icon} alt="" />
                    </div>
        
                    <div className={cls.Description}>
                        {buttonPopups?.msg}
                    </div>
                </div>
        
                <Iconfont className={cls.CloseIcon} onClick={onClose}>&#xe69a;</Iconfont>
            </div>
        }
    </React.Fragment>
}

export default PopupPrompt;